import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "./chunks/tslib.es6.js";
import s from "./Basemap.js";
import r from "./Ground.js";
import t from "./core/Accessor.js";
import o from "./core/CollectionFlattener.js";
import a from "./core/Evented.js";
import { isNone as i } from "./core/maybe.js";
import { property as l } from "./core/accessorSupport/decorators/property.js";
import "./core/arrayUtils.js";
import "./core/has.js";
import { cast as n } from "./core/accessorSupport/decorators/cast.js";
import { subclass as p } from "./core/accessorSupport/decorators/subclass.js";
import { isEditableLayer as d } from "./layers/support/editableLayers.js";
import { createCache as m, destroyCache as u, ensureType as c } from "./support/basemapUtils.js";
import { ensureType as y } from "./support/groundUtils.js";
import { LayersMixin as h } from "./support/LayersMixin.js";
import { TablesMixin as b } from "./support/TablesMixin.js";

var f = /*#__PURE__*/function (_b) {
  _inherits(f, _b);

  var _super = _createSuper(f);

  function f(e) {
    var _this;

    _classCallCheck(this, f);

    _this = _super.call(this, e), _this.allLayers = new o({
      getCollections: function getCollections() {
        var e, s, r;
        return [null == (e = _this.basemap) ? void 0 : e.baseLayers, null == (s = _this.ground) ? void 0 : s.layers, _this.layers, null == (r = _this.basemap) ? void 0 : r.referenceLayers];
      },
      getChildrenFunction: function getChildrenFunction(e) {
        return "layers" in e ? e.layers : null;
      }
    }), _this.allTables = new o({
      getCollections: function getCollections() {
        return [_this.tables, _this.layers];
      },
      getChildrenFunction: function getChildrenFunction(e) {
        var s = [];
        return "tables" in e && s.push(e.tables), "layers" in e && s.push(e.layers), s;
      },
      itemFilterFunction: function itemFilterFunction(e) {
        var s = e.parent;
        return s && "tables" in s && s.tables.includes(e);
      }
    }), _this.basemap = null, _this.editableLayers = new o({
      getCollections: function getCollections() {
        return [_this.allLayers];
      },
      itemFilterFunction: d
    }), _this.ground = new r(), _this._basemapCache = m();
    return _this;
  }

  _createClass(f, [{
    key: "destroy",
    value: function destroy() {
      var e, s;
      this.allLayers.destroy(), this.allTables.destroy(), this.editableLayers.destroy(), null == (e = this.ground) || e.destroy(), null == (s = this.basemap) || s.destroy(), u(this._basemapCache), this._basemapCache = null;
    }
  }, {
    key: "castBasemap",
    value: function castBasemap(e) {
      return c(e, this._basemapCache);
    }
  }, {
    key: "castGround",
    value: function castGround(e) {
      var s = y(e);
      return i(s) ? this._get("ground") : s;
    }
  }, {
    key: "findLayerById",
    value: function findLayerById(e) {
      return this.allLayers.find(function (s) {
        return s.id === e;
      });
    }
  }, {
    key: "findTableById",
    value: function findTableById(e) {
      return this.allTables.find(function (s) {
        return s.id === e;
      });
    }
  }]);

  return f;
}(b(h(a.EventedMixin(t))));

e([l({
  readOnly: !0,
  dependsOn: []
})], f.prototype, "allLayers", void 0), e([l({
  readOnly: !0
})], f.prototype, "allTables", void 0), e([l({
  type: s
})], f.prototype, "basemap", void 0), e([n("basemap")], f.prototype, "castBasemap", null), e([l({
  readOnly: !0
})], f.prototype, "editableLayers", void 0), e([l({
  type: r,
  nonNullable: !0
})], f.prototype, "ground", void 0), e([n("ground")], f.prototype, "castGround", null), f = e([p("esri.Map")], f);
var j = f;
export { j as default };